import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

class RlConditionalLabel extends PureComponent {
    render() {
        let {
            fieldValue = '',
            labelText,
            error
        } = this.props;
        let className = classNames({
            'rl-conditional-label': true,
            'rl-conditional-label-inactive': !error && (fieldValue || '').length === 0,
            'error': error
        });

        return (
            <label className={className}>{labelText}</label>
        );
    }
}

RlConditionalLabel.propTypes = {
    fieldValue: PropTypes.string,
    labelText: PropTypes.string.isRequired,
    error: PropTypes.bool
};

export default RlConditionalLabel;
